
async function base64ToFile ({data, filename, content_type}){
  try {
    let res = await fetch(data)
    res = await res.blob()
    let blob = new File([res], filename, { type: content_type }) 
    // console.log({blob});
    return blob
    
  } catch (error) {
    throw (error)
  }
}

export default base64ToFile
